import { render, staticRenderFns } from "./Years.vue?vue&type=template&id=1cd7eb95&"
import script from "./Years.vue?vue&type=script&lang=js&"
export * from "./Years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports